import React from 'react';
import PropTypes from 'prop-types';
import './TextButton.css';

const TextButton = React.forwardRef(
  ({ onClick, underline, className, children, ...otherProps }, ref) => (
    <button
      ref={ref}
      className={`text-button ${underline ? 'underline' : ''} ${
        className || ''
      }`}
      onClick={onClick}
      type="button"
      {...otherProps}
    >
      {children}
    </button>
  )
);

TextButton.propTypes = {
  onClick: PropTypes.func,
  underline: PropTypes.bool,
  className: PropTypes.string
};

export default TextButton;
